import axios from 'axios';
import config from '../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/indicador';
const endpoint2 = '/api/indicadores';
const endpointdetalle = '/api/indicadores/detalle/'
const endpoinTIPO = '/api/tipoResultados'
const endpoinCreate = '/api/agregarResultados'
const periodo = '/api/tiposperiodo'
const soloIndicadoresEndpoint = '/api/solo-indicadores'; 

const getSoloIndicadores = async () => {
  try {
    const response = await axios.get(`${baseUrl}${soloIndicadoresEndpoint}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener solo indicadores:', error);
    throw error;
}
};
const getIndicador = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los indicadores:', error);
    throw error;
  }
};


const getIndicadores = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint2}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los indicadores:', error);
    throw error;
  }
};
const getIndicadoresDetalle = async (indicadorId, municipio_ids) => {
  try {
    // Convertir el array de IDs a una cadena separada por comas
    const municipioIdsParam = municipio_ids.length > 0 ? municipio_ids.join(',') : undefined;

    const response = await axios.get(`${baseUrl}${endpointdetalle}${indicadorId}`, {
      params: {
        municipio_ids: municipioIdsParam, // Usar la cadena de parámetros
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los indicadores:', error);
    throw error;
  }
};


const endpointUpdate = '/api/detalleResultado/actualizar/'

const updateteDetalleResultado = async (data) => {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error('Los datos enviados deben ser un array de objetos con al menos un registro.');
    }
    const response = await axios.post(`${baseUrl}${endpointUpdate}`, data);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    // Si el error es una respuesta del servidor (error 4xx o 5xx)
    if (error.response) {
      console.error('Error en la respuesta del servidor:', error.response.data);
      throw new Error(`Error en el servidor: ${error.response.status} - ${error.response.data.message}`);
    }
    console.error('Error de red o desconocido:', error);
    throw new Error('Error de red o desconocido. Verifique su conexión.');
  }
};

const getTiposDeResultados = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoinTIPO}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los resultados:', error);
    throw error;
  }
};
const createDetalleResultado = async (data) => {
  try {
    // Validar que data sea un objeto con la estructura esperada
    if (!data || typeof data !== 'object') {
      throw new Error('Los datos enviados deben tener el formato adecuado.');
    }

    // Reformatear los datos en la estructura que el backend espera
    const formattedData = {
      detalleClasificacion: {
        id_desagregacion: data.id_desagregacion,
        id_clasificasion: data.id_clasificasion,
        id_periodicidad: data.id_periodicidad,
        id_tipo_resultado: data.id_tipo_resultado,
      },
      detalleIndicador: {
        indicador_id: data.indicador_id,
      },
      detalleResultado: {
        municipio_id: data.municipio_id,
        valor_periocidad: data.valor_periocidad,
        valor_resultado: data.valor_resultado,
      }
    };

    // Realizar la petición POST al backend
    const response = await axios.post(`${baseUrl}${endpoinCreate}`, formattedData);

    return {
      status: response.status,
      data: response.data,
    };

  } catch (error) {
    // Manejar el error en la respuesta del servidor
    if (error.response) {
      console.error('Error en la respuesta del servidor:', error.response.data);
      throw new Error(`Error en el servidor: ${error.response.status} - ${error.response.data.message}`);
    }
    // Manejar otros errores como de red o desconocidos
    console.error('Error de red o desconocido:', error);
    throw new Error('Error de red o desconocido. Verifique su conexión.');
  }
};
 const gettiposperiodo = async () => {
  try {
    const response = await axios.get(`${baseUrl}${periodo}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los resultados:', error);
    throw error;
  }
};

export { getSoloIndicadores,getIndicador,getIndicadores, getIndicadoresDetalle, updateteDetalleResultado, getTiposDeResultados, createDetalleResultado, gettiposperiodo };
